
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./MPCompSuctDrumA.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function MPCompSuctDrumA() {

        useEffect(() => {
  
    trackPageVisit("MPCompSuctDrumA");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorA, compressorB,  compressorC} = useContext(CompressorContext);

const compressor = compressorC; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    
      const historianData = useMemo(() => {
  return {
    time: compressor.history?.time || [],
    PT_suction: compressor.history?.PT_suction || [],
    PT_discharge: compressor.history?.PT_discharge || [],
    TT_suction: compressor.history?.TT_suction || [],
    TT_discharge: compressor.history?.TT_discharge || [],
    FIC_suction: compressor.history?.FIC_suction || [],
    FIC_discharge: compressor.history?.FIC_discharge || [],
    speed: compressor.history?.speed || []
  };
}, [compressor.history]);




  const DEFAULT_VALVES = {
  FCV_18001A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_18001A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_18002A: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("MPCompSuctDrumA_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_18001A: { ...DEFAULT_VALVES.FCV_18001A, ...parsed.FCV_18001A },
      PCV_18001A: { ...DEFAULT_VALVES.PCV_18001A, ...parsed.PCV_18001A },
      PCV_18002A: { ...DEFAULT_VALVES.PCV_18002A, ...parsed.PCV_18002A },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("MPCompSuctDrumA_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO MP COMPRESSOR =================

  const [FIC_14004, setFIC_14004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_14004")) || 0;
            setFIC_14004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_14004, setPT_14004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_14004")) || 0;
            setPT_14004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_14004, setTT_14004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_14004")) || 0;
            setTT_14004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const [FIC_17003A, setFIC_17003A] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_17003A")) || 0;
            setFIC_17003A(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_17008A, setPT_17008A] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_17008A")) || 0;
            setPT_17008A(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_17008A, setTT_17008A] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_17008A")) || 0;
            setTT_17008A(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV18001AOpen = valves?.XV_18001A === false;
  const isXV18002AOpen = valves?.XV_18002A === false;
  const isXV18003AOpen = valves?.XV_18003A === false;
  const isXV18004AOpen = valves?.XV_18004A === false;
  const isXV18005AOpen = valves?.XV_18005A === false;
  const isXV18006AOpen = valves?.XV_18006A === false;

    const isP18001AOn = pumpData?.["P-18001A"]?.running ?? false;




  const FIC_18009A = FIC_17003A;
  const PT_18005A = PT_17008A;

 const FIC_180011A = isXV18001AOpen ? FIC_14004 : 0;
const PT_18001A = isXV18001AOpen ? PT_14004 : 0.03;

const FIC_18001A =
  PT_18005A > PT_18001A
    ? (FIC_180011A ?? 0) + (FIC_18009A ?? 0)
    : (FIC_180011A ?? 0); 

 const TT_18001A = isXV18001AOpen ? TT_14004 : 22;


const FIC_18004A = isXV18006AOpen ? 30.54 : 0;
const PT_18006A = isXV18006AOpen ? 1.3 : 0.03;
const TT_18004A = isXV18006AOpen ? 24 : 28;


const coolerResults = simulateCooler({

  coolerId: "MP_COOLER_A",

  gasFlow: FIC_18001A,
  gasTempIn: TT_18001A,
  gasPressureIn: PT_18001A,

  waterFlow: FIC_18004A,
  waterTempIn: TT_18004A,
  waterPressureIn: PT_18006A,

  gasValveOpen: isXV18001AOpen,
  waterValveOpen: isXV18006AOpen,

  designEfficiency: 0.84,

  foulingFactor: 0.02
});


const TT_18003A = isXV18001AOpen && !isXV18006AOpen? TT_18001A : (isXV18001AOpen) ? 
  coolerResults.gasTempOut*0.45 : 24;

const PT_18002A = isXV18001AOpen && !isXV18006AOpen? PT_18001A : (isXV18001AOpen) ? 
  coolerResults.gasPressureOut*0.222 : 0.03;

const TT_18002A = isXV18001AOpen && !isXV18006AOpen? TT_18004A : (isXV18001AOpen) ? 
  coolerResults.waterTempOut*1.24 : TT_18004A;


const TT_18005A = TT_18003A * 0.95;

const FIC_18006A = FIC_18001A * 0.78;

const PT_18003A =  isXV18005AOpen ? PT_18002A * ((valveData?.PCV_18001A?.opening || 0)/100) : 0.03;



// ======================================================
// SINGLE STAGE COMPRESSOR SIMULATION
// ======================================================

const compressorResults =
  simulateSingleStageCompressor({

    suctionPressure: PT_18003A,
    suctionTemperature: TT_18005A,
    suctionFlow: FIC_18006A,

    isRunning: compressor.running,

    compressorEfficiency: 0.82,

    compressionRatio: 2.8
  });


useEffect(() => {

  const interval = setInterval(() => {

    updateCompressor(compressor, {
      suctionPressure: PT_18003A,
      suctionTemperature: TT_18005A,
      suctionFlow: FIC_18006A
    });

    forceRender(v => v + 1);

  }, 200); // DCS-like scan time

  return () => clearInterval(interval);

}, [PT_18003A, TT_18005A, FIC_18006A]);

// ======================================================
// DISCHARGE VALUES
// ======================================================

const FIC_18003A =
  compressorResults.dischargeFlow*1.22;

const PT_18008A =
  compressorResults.dischargePressure*20.3;

const TT_18008A =
  compressorResults.dischargeTemperature*1.25;

const PT_18004A = isXV18004AOpen ? 0.3 : 0.03;
const FIC_18008A = isXV18004AOpen ? 1.432 : 0;
const FIC_18007A = compressor.running ? 1.3 + 1.432 : FIC_18008A;

const FIC_18002A = FIC_18003A * 0.3 * (valveData?.PCV_18002A?.opening || 0)/100;

  
  // ================= MP CONDENSATE PUMP (A) =================

const runningPumps18001A = [isP18001AOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow18001A = 0;
const suctionPressure18004A = PT_18004A;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_180051A =  1.3 * (valveData?.FCV_18001A?.opening || 0)/100;
const MIN_DISCH_PRESSURE_180051A = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_180051A = MAX_DISCH_PRESSURE_180051A;
let targetFIC_18005A = 0;

if (runningPumps18001A > 0) {

  // 🔹 Flow boost
  targetFIC_18005A = isXV18004AOpen ? 50 * (valveData?.FCV_18001A?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_180051A = isXV18004AOpen ? MIN_DISCH_PRESSURE_180051A* (valveData?.FCV_18001A?.opening || 0)/100 : 0.03;

}

// ================= STATES =================
const [PT_180051A, setPT_180051A] = useState(() => {
  return Number(localStorage.getItem("PT_180051A")) || 0.03;
});

const [FIC_18005A, setFIC_18005A] = useState(() => {
  return Number(localStorage.getItem("FIC_18005A")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_180051A(prev => {
      const next = prev + (targetPT_180051A - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_18005A(prev => {
      const next = prev + (targetFIC_18005A - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_180051A, targetFIC_18005A]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_180051A", PT_180051A);
}, [PT_180051A]);

useEffect(() => {
  localStorage.setItem("FIC_18005A", FIC_18005A);
}, [FIC_18005A]);


useEffect(() => {
  localStorage.setItem("FIC_18003A", FIC_18003A);
}, [FIC_18003A]);

useEffect(() => {
  localStorage.setItem("PT_18008A", PT_18008A);
}, [PT_18008A]);

useEffect(() => {
  localStorage.setItem("TT_18008A", TT_18008A);
}, [TT_18008A]);







  return (
    <div className="MPCompSuctDrumA-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 200px"
      }}>
        MP COMPRESSOR SUCTION DRUM (A)
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-18001A"
        tag="XV_18001A"
        x={115}
        y={122}
        isClosed={valves.XV_18001A}
        toggle={toggleValve}
      />

      {/* XV-18002A */}
      <Valve
        className="XV-18002A"
        tag="XV_18002A"
        x={878}
        y={186}
        isClosed={valves.XV_18002A}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-18003A */}
      <Valve
        className="XV-18003A"
        tag="XV_18003A"
        x={1025}
        y={186}
        isClosed={valves.XV_18003A}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-18004A */}
      <Valve
        className="XV-18004A"
        tag="XV_18004A"
        x={571}
        y={620}
        isClosed={valves.XV_18004A}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-18005A */}
      <Valve
        className="XV-18005A"
        tag="XV_18005A"
        x={882}
        y={596}
        isClosed={valves.XV_18005A}
        toggle={toggleValve}
        r={270}
      />

      
      {/* XV-18006A */}
      <Valve
        className="XV-18006A"
        tag="XV_18006A"
        x={286}
        y={502}
        isClosed={valves.XV_18006A}
        toggle={toggleValve}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-18001A */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18001A"
          style={{ position: "absolute", left: 92, top: 722}}  onClick={() => openPanel("FCV_18001A")}>
          
          <defs>
            <linearGradient id="metal_18001A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,140 20,110"
            fill="url(#metal_18001A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,140 180,110"
            fill="url(#metal_18001A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* PCV-18001A */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-18001A"
          style={{ position: "absolute", left: 855, top: 520, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_18001A")}>
          
          <defs>
            <linearGradient id="metal_18001A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,140 20,110"
            fill="url(#metal_18001A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,140 180,110"
            fill="url(#metal_18001A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-18002A */}
        <svg width="30" height="30" viewBox="0 0 200 220" className="PCV-18002A"
          style={{ position: "absolute", left: 707, top: 64}}  onClick={() => openPanel("PCV_18002A")}>
          
          <defs>
            <linearGradient id="metal_18002A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,140 20,110"
            fill="url(#metal_18002A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,140 180,110"
            fill="url(#metal_18002A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 140 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 140 + index * 40
              }}
            />
          ))}


          <div
              onClick={() => setOpen(true)}
              style={{
                position: "absolute",
                left: 900,
                top: 350,
                width: 140,
                height: 30,

                background:

                  compressor.status === "RUNNING"
                    ? "#00aa00"

                  : compressor.status === "STARTING"
                    ? "#d4aa00"

                  : compressor.status === "SHUTTING DOWN"
                    ? "#ff8800"

                  : compressor.status === "READY"
                    ? "#0099ff"

                  : compressor.status === "TRIPPED"
                    ? "#ff3300"

                  : "#666666",

                color: "white",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                border: "2px solid cyan",

                cursor: "pointer",

                fontWeight: "bold",

                borderRadius: "8px",

                boxShadow:
                  compressor.running
                    ? "0 0 15px lime"
                    : "0 0 10px red",

                transition: "0.3s"
              }}
            >
              {compressor.status}
            </div>


          {open && (
            <SingleStageCompressorFaceplate
              input={{
                PT_18003A,
                TT_18005A,
                FIC_18006A,
                FIC_18003A,
                PT_18008A,
                TT_18008A,
                isXV18001AOpen,
                isXV18006AOpen
              }}
              compressor={compressor}
              close={() => setOpen(false)}
              openTrend={() => setShowTrend(true)}
            />
          )}




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_18001A?.opening || 0)}
        x={117}
        y={762}
      />
      <ValveOutput
        value={Number(valveData?.PCV_18001A?.opening || 0)}
        x={915}
        y={535}
      />
      <ValveOutput
        value={Number(valveData?.PCV_18002A?.opening || 0)}
        x={707}
        y={90}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
        tag="FIC-18001A"
        value={[FIC_18001A]}
        x={226}
        y={117}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF MP COMPRESSOR"
      />

      <Transmitter
        tag="PT-18001A"
        value={[PT_18001A]}
        x={226}
        y={167}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF MP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-18001A"
        value={[TT_18001A]}
        x={326}
        y={117}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF MP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-18004A"
        value={[TT_18004A]}
        x={426}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO MP GAS COOLER (A) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="PT-18006A"
        value={[PT_18006A]}
        x={426}
        y={373}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO MP GAS COOLER (A) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-18004A"
        value={[FIC_18004A]}
        x={146}
        y={493}
        unit="MPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO MP GAS COOLER (A) FOR HEAT EXCHANGING WITH GAS"
      />


      <Transmitter
        tag="TT-18003A"
        value={[TT_18003A]}
        x={258}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF COOLED GAS AT THE DISCHARGE OF THE MP GAS COOLER (A) TO MP COMPRESSOR SUCTION DRUM (A)"
      />

      <Transmitter
        tag="PT-18002A"
        value={[PT_18002A]}
        x={676}
        y={269}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF COOLED GAS AT THE DISCHARGE OF THE MP GAS COOLER (A) TO MP COMPRESSOR SUCTION DRUM (A)"
      />

      <Transmitter
        tag="TT-18002A"
        value={[TT_18002A]}
        x={543}
        y={116}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER AT THE DISCHARGE OF THE MP GAS COOLER (A) TO FRESH WATER RETURN LINE"
      />
      <Transmitter
        tag="TT-18005A"
        value={[TT_18005A]}
        x={920}
        y={666}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE SUCTION OF MP COMPRESSOR (A)"
      />

      <Transmitter
        tag="FIC-18006A"
        value={[FIC_18006A]}
        x={826}
        y={666}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF MP COMPRESSOR (A)"
      />

      <Transmitter
        tag="PT-18003A"
        value={[PT_18003A]}
        x={776}
        y={492}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF MP COMPRESSOR (A)"
      />
      
      <Transmitter
        tag="FIC-18003A"
        value={[FIC_18003A]}
        x={936}
        y={132}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF MP COMPRESSOR (A)"
      />

      <Transmitter
        tag="PT-18008A"
        value={[PT_18008A]}
        x={1036}
        y={132}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF MP COMPRESSOR (A)"
      />

      <Transmitter
        tag="TT-18008A"
        value={[TT_18008A]}
        x={1124}
        y={132}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE DISCHARGE OF MP COMPRESSOR (A)"
      />

      <Transmitter
        tag="PT-18004A"
        value={[PT_18004A]}
        x={466}
        y={706}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE BOTTOM LEVEL OF MP COMPRESSOR SUCTION DRUM (A) GOING TO MP CONDENSATE PUMP"
      />


      <Transmitter
        tag="FIC-18008A"
        value={[FIC_18008A]}
        x={656}
        y={720}
        unit="MPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF MP COMPRESSOR SUCTION DRUM (A) GOING TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-18005A"
        value={[FIC_18005A]}
        x={226}
        y={667}
        unit="MPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE DISCHARGE OF MP CONDENSATE PUMP (A) GOING BACK TO 3RD STAGE SEPARATOR"
      />

      <Transmitter
        tag="PT-180051A"
        value={[PT_180051A]}
        x={226}
        y={680}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE DISCHARGE OF MP CONDENSATE PUMP (A) GOING BACK TO 3RD STAGE SEPARATOR"
      />


      <Transmitter
        tag="FIC-18002A"
        value={[FIC_18002A]}
        x={426}
        y={117}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS RETURNED FROM THE DISCHARGE OF THE MP COMPRESSOR FOR ANTI-SURGE PROTECTION"
      />

      <Transmitter
        tag="FIC-18007A"
        value={[FIC_18007A]}
        x={1106}
        y={720}
        unit="LPM"
        max={10}
        HH={9}
        H={8}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF MP COMPRESSOR SUCTION DRUM (A) AND COMPRESSOR DURING PURGING AND BLOWDOWN GOING TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-18009A"
        value={[FIC_18009A]}
        x={97}
        y={268}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={10}
        LL={5}
        c="lime"
        description="FLOWRATE OF GAS FROM DISCHARGE OF LP COMPRESSOR SUCTION DRUM (A) AND COMPRESSOR TO INLET OF MP GAS COOLER (A)"
      />

      <Transmitter
        tag="PT-18005A"
        value={[PT_18005A]}
        x={97}
        y={333}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS FROM DISCHARGE OF LP COMPRESSOR SUCTION DRUM (A) AND COMPRESSOR TO INLET OF MP GAS COOLER (A)"
      />










      <Pump
        tag="P-18001A"
        x={375}
        y={749}
        rpm={1800}
        bladeCount={pumpData?.["P-18001A"]?.bladeCount || 5}
        size={pumpData?.["P-18001A"]?.size || 35}
        onClick={openPumpPanel}
      />

      <LevelTransmitterIndicator
      tag="LT_18001A"
      totalLevel={100000}
      inflows={[FIC_18001A * 0.08]}
      outflows={[FIC_18005A]}
      responseFactor={0.05}
      columnX={626}
      columnY={410}
      columnWidth={52}
      columnHeight={147}
      textX={529}
      textY={470}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />





      
           
          {showTrend && (
            <CompressorTrendFaceplate
              data={historianData}
              close={() => setShowTrend(false)}
            />
          )}


    </div>
  );
}


export default MPCompSuctDrumA;